"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _GoodsManageContent = _interopRequireDefault(require("@/views/integral/components/GoodsManageContent.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'IntegralGoodsManage',
  components: {
    GoodsManageContent: _GoodsManageContent.default
  },
  computed: {
    activityId: function activityId() {
      return this.$route.params.activityId || '';
    },
    displayTitle: function displayTitle() {
      var n = this.$route.query.name;
      var base = this.activityType === 1 ? '积分获取商品管理' : '积分兑换商品管理';
      return n ? "".concat(base, " - ").concat(n) : base;
    },
    readonly: function readonly() {
      var r = this.$route.query.readonly;
      return r === '1' || r === 'true';
    },
    /** 1-积分发放（返积分） 2-积分兑换，与接口 activityType 一致 */activityType: function activityType() {
      return this.$route.name === 'pointsGoodsManage' ? 1 : 2;
    }
  },
  methods: {
    goBack: function goBack() {
      var menu = this.$route.meta && this.$route.meta.activeMenu;
      this.$router.push(menu || '/integral/exchangeConfig');
    }
  }
};